module.exports = __webpack_public_path__ + "static/media/boletoB.21131c3a.svg";